import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "CARD_RECORDS";
export const cardSearchConstants = createCRUDConstants(nameSpace);
